import { render, staticRenderFns } from "./wxlist.vue?vue&type=template&id=1606f00c&scoped=true&"
import script from "./wxlist.vue?vue&type=script&lang=js&"
export * from "./wxlist.vue?vue&type=script&lang=js&"
import style0 from "./wxlist.vue?vue&type=style&index=0&id=1606f00c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606f00c",
  null
  
)

export default component.exports